import { render, staticRenderFns } from "./AppMenulists.vue?vue&type=template&id=cc16ac8c"
import script from "./AppMenulists.vue?vue&type=script&lang=js"
export * from "./AppMenulists.vue?vue&type=script&lang=js"
import style0 from "./AppMenulists.vue?vue&type=style&index=0&id=cc16ac8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports